// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    .Filter_container__f4IkN {
        height: 90px;
        display: grid;
        align-items: center;
        justify-content: space-between;
        grid-template-columns: 29% 29% 29% 29%;
    }
}


.Filter_datapicker__ncBAp {
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 10px;
    width: 120%;
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px) {
    .Filter_container__f4IkN {
        height: 90px;
        display: grid;
        align-items: center;
        justify-content: space-between;
        grid-template-columns: 29% 29% 29% 29%;
        width: 100%;
    }
}

/*MOBILE*/
@media screen and (max-width:767px) {
    .Filter_container__f4IkN {
        height: 60px;
        display: grid;
        align-items: center;
        justify-content: space-between;
        grid-template-columns: 29% 29% 29% 29%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/filter/Filter.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,sCAAsC;IAC1C;AACJ;;;AAGA;IACI,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,WAAW;AACf;;AAEA,SAAS;AACT;IACI;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,sCAAsC;QACtC,WAAW;IACf;AACJ;;AAEA,SAAS;AACT;IACI;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,sCAAsC;IAC1C;AACJ","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .container {\n        height: 90px;\n        display: grid;\n        align-items: center;\n        justify-content: space-between;\n        grid-template-columns: 29% 29% 29% 29%;\n    }\n}\n\n\n.datapicker {\n    display: grid;\n    grid-template-columns: auto auto;\n    column-gap: 10px;\n    width: 120%;\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px) {\n    .container {\n        height: 90px;\n        display: grid;\n        align-items: center;\n        justify-content: space-between;\n        grid-template-columns: 29% 29% 29% 29%;\n        width: 100%;\n    }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px) {\n    .container {\n        height: 60px;\n        display: grid;\n        align-items: center;\n        justify-content: space-between;\n        grid-template-columns: 29% 29% 29% 29%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Filter_container__f4IkN`,
	"datapicker": `Filter_datapicker__ncBAp`
};
export default ___CSS_LOADER_EXPORT___;
